<template>
  <div>
    <template v-if="item.typeIdentifier === 'item' && hasCustomButtons">
          <v-btn text @click="executeAction('imagesFromDisk')">Изобр. с диска</v-btn>
          <v-btn text @click="executeAction('submitToChannels')">В каналы</v-btn>
    </template>
  <ActionStatusDialog ref="actionStatusDialogRef" />
</div>
</template>
<script>
import ActionStatusDialog from '../../../components/ActionStatusDialog.vue'
import { ref } from '@vue/composition-api'
import * as actionsStore from '../../../store/actions'
import * as errorStore from '../../../store/error'
import * as usersStore from '../../../store/users'

export default {
  components: {
    ActionStatusDialog
  },
  props: {
    item: {
      required: true
    }
  },
  setup (props) {
    const { executeActionByIdentifier } = actionsStore.useStore()
    const { showInfo, showError } = errorStore.useStore()

    const { currentRoles } = usersStore.useStore()

    const actionStatusDialogRef = ref(null)

    const hasCustomButtons = ref(currentRoles.some(role => role.identifier === 'admin'))

    async function executeAction (actionIdentifier, data) {
      if (!confirm('Выполнить?')) return

      actionStatusDialogRef.value.showDialog()
      try {
        const resp = await executeActionByIdentifier(props.item.id, actionIdentifier, data)
        if (resp.error || resp.compileError) {
          showError('ОШИБКА: ' + resp.error || resp.compileError)
        } else if (resp.message) {
          showInfo(resp.message)
        }
        if (resp.data) {
          if (resp.data.openUrl) {
            window.open(resp.data.openUrl)
          }
        }
      } catch (e) {
        showError('ОШИБКА: ' + e.message)
      } finally {
        actionStatusDialogRef.value.closeDialog()
      }
    }

    return {
      actionStatusDialogRef,
      hasCustomButtons,
      executeAction
    }
  }
}
</script>
